module.exports = __webpack_public_path__ + "static/talos-symbol-DND3_FnP-a4e1f7a3c3e9ac534e7db747d20e7e29.jpg";